var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 11,
    viewBox: "0 0 30 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2264 1.49052C11.7113 0.0393991 9.74179 0.0377734 9.22829 1.4889C7.62929 6.4484 5.48754 9.50827 6.80379 10.1111C8.55554 10.9058 8.59292 9.11827 9.01217 8.32365H12.4425C12.8602 9.11502 12.9008 10.9041 14.6509 10.1111C15.972 9.50827 13.8563 6.54427 12.2264 1.49052ZM9.60367 6.3444L10.7282 3.17402L11.851 6.3444H9.60367Z",
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.07044 10.2817C2.12369 10.2817 3.27419 7.58911 2.94594 2.57598C2.24881 2.45573 0.0859375 3.05861 0.0859375 1.48236C0.0859375 0.879483 0.581562 0.388733 1.18931 0.388733C5.28106 0.681233 8.05331 -0.375017 8.05331 1.48236C8.05331 3.08623 5.98144 2.44111 5.19331 2.57598C4.86831 7.57286 6.01394 10.2817 4.07044 10.2817Z",
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.7272 10.1176C14.8439 10.1176 15.9895 7.57447 15.6499 1.50347C15.6499 0.0247227 17.946 0.0263478 17.946 1.50347V8.06847C19.0331 8.2131 21.4154 7.53222 21.4154 9.09222C21.4137 10.7286 18.8544 9.9096 16.7272 10.1176Z",
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.1312 9.794L24.4922 6.32138L24.1022 6.70975V9.14725C24.1022 9.76475 23.5985 10.2653 22.9761 10.2653C21.0212 10.2653 22.1928 7.45075 21.8516 1.50325C21.8516 0.887378 22.3553 0.385254 22.9761 0.385254C24.6742 0.385254 23.9413 2.787 24.1006 3.905C27.2856 0.861378 27.2092 0.538004 27.8641 0.538004C28.7676 0.538004 29.3217 1.66088 28.7205 2.25725L26.1562 4.80363L28.9252 8.4485C29.8287 9.62663 28.0233 10.977 27.1312 9.794Z",
    fill: "#FFEB3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/TALK.1df3174cf693e9d03438ebbedba34dec.svg";
export { ForwardRef as ReactComponent };